import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { db } from '../../firebase';
import { collectionGroup, onSnapshot } from 'firebase/firestore';

const PostNotifier = () => {
  const user = useSelector((state) => state.auth.user);
  const ready = useRef(false);

  useEffect(() => {
    if (!user?.uid) return;

    // 1. Запрашиваем разрешение на уведомления в браузере
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission();
    }

    ready.current = false;

    // 2. Слушаем ВСЕ посты в системе (лента + группы)
    const unsubscribe = onSnapshot(collectionGroup(db, 'posts'), (snap) => {
      // Пропускаем самый первый снимок при загрузке (чтобы не спамить старыми постами)
      if (!ready.current) {
        ready.current = true;
        return;
      }

      snap.docChanges().forEach((change) => {
        if (change.type !== 'added') return;
        
        const post = change.doc.data();
        
        // Показываем уведомление, если:
        // 1. Пользователь отмечен в посте ИЛИ
        // 2. Это пост в группе, где состоит пользователь
        const isTagged = (post.taggedUsers || []).includes(user.uid);
        const isInGroup = post.groupId && (post.members || []).includes(user.uid); // Если в документе поста есть members, или можно проверять отдельно

        if (isTagged || isInGroup) {
          const author = post.authorName || post.authorEmail || 'Коллега';
          const location = post.groupId ? `в группе` : 'в ленте';
          const text = post.text ? (post.text.length > 50 ? post.text.slice(0, 50) + '...' : post.text) : 'Новое вложение';

          // Отправляем нативное уведомление браузера/телефона
          if ('Notification' in window && Notification.permission === 'granted') {
            new Notification(`🔔 Новая отметка ${location}`, {
              body: `${author}: «${text}»`,
              icon: '/favicon.ico', // Или URL вашей иконки
              tag: change.doc.id, // Чтобы не дублировать уведомления с одинаковым ID
            });
          }
        }
      });
    });

    return () => unsubscribe();
  }, [user?.uid]);

  return null; // Этот компонент ничего не рендерит, только работает в фоне
};

export default PostNotifier;